export default __webpack_public_path__ + "static/media/Vambraces of Heroic Soul.6180bf64.jpg";